export const salesTaxRate = 0.1025; // Full amount to avoid IEEE754 errors from adding them individually

export const firstYearOfBusiness = 2023;
